module.exports = "/_next/static/images/mail_footer-2c3a64815911fd6643726becaccaee46.png";